import type { ReactElement, ReactNode } from "react";
import { WorkspaceIdContext } from "./workspaceIdContext";

interface WorkspaceIdProviderProps {
    workspaceId: string;
    children: ReactNode;
}

/**
 * Shares the already resolved workspace id with the whole subtree: mounted by
 * ViewWrapper, which waits for the workspace before rendering the views, so
 * from there down every hook reads it on its FIRST render (see useWorkspaceId
 * for why that matters).
 */
export const WorkspaceIdProvider = ({
    workspaceId,
    children,
}: WorkspaceIdProviderProps): ReactElement => (
    <WorkspaceIdContext.Provider value={workspaceId}>
        {children}
    </WorkspaceIdContext.Provider>
);
